import { render, staticRenderFns } from "./PFilePreview.vue?vue&type=template&id=099e8cc4&scoped=true&"
import script from "./PFilePreview.vue?vue&type=script&lang=js&"
export * from "./PFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./PFilePreview.vue?vue&type=style&index=0&id=099e8cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099e8cc4",
  null
  
)

export default component.exports